import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { TextField } from 'redux-form-material-ui'
import { required, money } from '../form/validation'
import FlatButton from 'material-ui/FlatButton'
import Send from 'material-ui/svg-icons/content/send'
import { themeColors } from '../styles/theme'
import Dialog from 'material-ui/Dialog'

const styles = {
  request: {
    paddingTop: 30,
    display: 'inline-flex',
  },
  requestNum: {
    fontWeight: 'bold',
    marginLeft: 10,
  },
}

class BuyForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      confirmOpen: false,
    }
  }

  toggleConfirmOpen = () => {
    this.setState(state => ({ confirmOpen: !state.confirmOpen }))
  }

  render() {
    const {
      handleSubmit,
      submitting,
      toggleOpen,
      item,
      owner,
      givenMoney,
      initialValues: { requestedMoney },
    } = this.props

    return (
      <form onSubmit={handleSubmit}>

        <div style={styles.request}>
          <div>Richiesta</div>
          <div style={styles.requestNum}>{requestedMoney} € *</div>
        </div>
        <p style={{ marginTop: 0 }}>
          <small>
            * la somma potrebbe non essere comprensiva di spese di spedizione,
            controlla sempre nelle note dell’oggetto oppure chiedi al venditore prima di fare un’offerta
          </small>
        </p>

        <div>
          <Field
            name="money"
            disabled={submitting}
            component={TextField}
            style={{ width: '100%' }}
            hintText="Tua Offerta"
            floatingLabelText="Tua Offerta €"
            validate={[required, money]}
            min={0}
          />
        </div>

        <div style={{ overflow: 'auto', marginTop: '40px' }}>
          <FlatButton
            type="button"
            onClick={this.toggleConfirmOpen}
            disabled={submitting}
            label="OK"
            primary={true}
            icon={<Send />}
            style={{ float: 'right', marginRight: 10 }}
          />
          <FlatButton
            type="button"
            label="Annulla"
            secondary={true}
            onClick={toggleOpen}
            style={{ float: 'left', marginLeft: 10 }}
          />

          <Dialog
            title="Offerta di acquisto"
            titleStyle={{ backgroundColor: themeColors.lightBackground }}
            contentClassName="fullwidth-for-small"
            modal={false}
            open={this.state.confirmOpen}
            onRequestClose={this.toggleConfirmOpen}
            actions={[
              <FlatButton
                label="Annulla"
                primary={true}
                onClick={this.toggleConfirmOpen}
              />,
              <FlatButton
                label="Ok"
                primary={true}
                keyboardFocused={true}
                onClick={() => {
                  this.toggleConfirmOpen()
                  handleSubmit()
                }}
              />,
            ]}
            autoScrollBodyContent={true}>
            <p>
              Stai cercando di acquistare "
              {item.titolo}
              " da
              {' '}
              <b>{owner.user.username}</b>
              {' '}per {givenMoney} €.
            </p>
          </Dialog>
        </div>
      </form>
    )
  }
}

const selector = formValueSelector('buy-form')
const mapStateToProps = state => ({
  givenMoney: selector(state, 'money'),
})

export default connect(mapStateToProps)(
  reduxForm({
    form: 'buy-form',
  })(BuyForm)
)



// WEBPACK FOOTER //
// ./src/common/BuyForm.js